import { ApplicationConfig, provideZoneChangeDetection, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
// import * as Sentry from '@sentry/angular';
// import { GoogleAnalyticsService, NGX_GOOGLE_ANALYTICS_SETTINGS_TOKEN } from 'ngx-google-analytics';

import { routes } from './app.routes';
import { authInterceptor } from './core/interceptors/auth.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(
      withInterceptors([authInterceptor])
    ),
    importProvidersFrom(
      BrowserModule,
      ReactiveFormsModule,
      FormsModule
    ),
    // Sentry Error Tracking - DISABLED (package not installed)
    // {
    //   provide: ErrorHandler,
    //   useValue: Sentry.createErrorHandler({
    //     showDialog: false,
    //   }),
    // },
    // {
    //   provide: Sentry.TraceService,
    //   deps: [],
    // },
    // Google Analytics 4 - DISABLED (package not installed)
    // {
    //   provide: NGX_GOOGLE_ANALYTICS_SETTINGS_TOKEN,
    //   useValue: {
    //     trackingCode: 'G-RJ5GRQMR8B',
    //     isEnabled: true
    //   }
    // },
    // GoogleAnalyticsService,
  ]
};
